import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faPaperclip, faGlobeAmericas } from '@fortawesome/free-solid-svg-icons'

class ItemIconRow extends PureComponent {

  files() {
    const fileCount = this.props.item.fileConnection.totalCount
    if (fileCount !== undefined && fileCount > 0) {
      return (
        <FontAwesomeIcon icon={faPaperclip} fixedWidth title={`${fileCount} file${fileCount > 1 ? 's' : ''}`}/>
      )
    }
  }

  children() {
    if (this.props.item.hasChildren) {
      return (
        <FontAwesomeIcon icon={faBars} fixedWidth title="Has Children"/>
      )
    }
  }

  spatial() {
    const spatial = this.props.item.spatial
    if (spatial !== undefined && spatial !== null) {
      return (
        <FontAwesomeIcon icon={faGlobeAmericas} fixedWidth title="Has spatial data"/>
      )
    }
  }

  render() {
    return (
      <>
        { this.files() }
        { this.children() }
        { this.spatial() }
      </>
    )
  }
}

ItemIconRow.propTypes = {
  item: PropTypes.shape({
    fileConnection: PropTypes.shape({
      totalCount: PropTypes.number
    }),
    hasChildren: PropTypes.bool,
    spatial: PropTypes.shape({
      maxX: PropTypes.number
    })
  })
}

export default ItemIconRow